import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface ResultAppUsagesInfo {
  success: boolean
  info?: {
    eventId: string
  }
  message?: string
}

interface AppUsagesPostProps {
  execIllustrationRegistered: (deviceId: string) => Promise<ResultAppUsagesInfo>
  loading: loadStatus
}

const createEventId = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

// AppUsages ILLUSTRATION_REGISTERED 図解登録
export const useAppUsagesIllustrationRegistered = (): AppUsagesPostProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildUrl } = useApiUrl()

  const execIllustrationRegistered = async (
    deviceId: string,
  ): Promise<ResultAppUsagesInfo> => {
    try {
      setLoading(loadStatus.LOADING)

      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const header = Object.assign({}, axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const body = {
        eventId: createEventId(),
        deviceId,
        eventType: 'ILLUSTRATION_REGISTERED', // 図解登録
        clientOccurredAtUtc: new Date().toISOString(),
        source: 'web', // web側
        details: {},
      }

      const response = await axios.post(`${buildUrl("/app-usages")}`,
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
        )

      setLoading(loadStatus.LOADED)

      if (response.status === apiStatus.SUCCESS) {
        return { success: true, info: response.data }
      }

      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }

      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execIllustrationRegistered, loading }
}
